import { isPlatformBrowser } from '@angular/common';
import { Component, HostBinding, ViewChild, OnInit, OnDestroy, NgZone, PLATFORM_ID, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthFirebaseService } from '@shared/services/auth-firebase.service';
import { MatDrawer } from '@angular/material/sidenav';
import { Store } from '@ngrx/store';
import { AppState } from '@shared/redux/config-store-state.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subscription, filter, of } from 'rxjs';
import { AlertNotificationComponent } from '@shared/components/alert-notification/alert-notification.component';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  @HostBinding('class') public hostDarkMode: string = 'dark-mode';
  @ViewChild('sidenav', { static: false }) public sidenav!: MatDrawer;

  private subsDarkMode$!: Subscription;

  public isLoggedIn$!: Observable<boolean>;
  private auth$!: Subscription;
  private alert$!: Subscription;

  public devMode = 'production';

  constructor(
    private authFirebaseService: AuthFirebaseService,
    private store: Store<AppState>,
    private snackBar: MatSnackBar,
    private router: Router,
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {}

  ngOnInit(): void {
    this.userIsLoggedIn();
    this.alertNotifications();
    this.subsDarkMode$ = this.store.select(state => state.storeConfig.darkMode)
      .subscribe({
        next: dk => {
          dk ? this.hostDarkMode = 'dark-mode' : this.hostDarkMode = '';
        }
      });
    this.devMode = environment.env;

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe({
        next: () => {
          if (isPlatformBrowser(this.platformId)) {
            this.ngZone.runOutsideAngular(() => {
              setTimeout(() => {
                const container = document.querySelector('mat-drawer-content');
                if (container) {
                  container.scrollTo({ top: 0, behavior: 'auto' });
                }
              });
            });
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.subsDarkMode$) this.subsDarkMode$.unsubscribe();
    if (this.auth$) this.auth$.unsubscribe();
    if (this.alert$) this.alert$.unsubscribe();
  }


  userIsLoggedIn(): void {
    this.auth$ = this.authFirebaseService.isLoggedIn()
      .subscribe({
        next: user => {
          this.isLoggedIn$ = of(user === null ? false : true);
        }
      });
  }

  alertNotifications(): void {
    this.alert$ = this.store.select(state => state.storeAlert)
      .subscribe({
        next: alert => {
          if (alert.message && alert.alertType) {
            this.snackBar.openFromComponent(AlertNotificationComponent, {
              duration: 7500,
              horizontalPosition: 'end',
              verticalPosition: 'bottom',
              panelClass: [ `astrea-alert-${alert.alertType}` ],
              data: alert.message
            });
          }
        }
      });
  }

  handleMenu(): void {
    this.sidenav.toggle();
  }

}
